export default "__VITE_ASSET__7798eaa9__"